export default __webpack_public_path__ + "static/media/tag.37cb9b06.svg";